import { AccountSource } from '../shared/enums/account-source.enum';
import { Gender } from '../shared/enums/gender.enum';
import { BusinessLabel } from './business-label.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class User {
  public id!: string;

  public accountIdentifier!: string;

  public accountSource!: AccountSource;

  public businessLabel!: BusinessLabel;

  public className?: string;

  public emailAddress!: string;

  public firstName!: string;

  public gender!: Gender;

  public lastName!: string;

  public lastNamePrefix?: string;

  public name!: string;

  public school!: string;

  public schoolLevel!: string;

  public year!: number;

  public roles!: string[];

  public static fromDto(dto: any): User {
    const user: User = new User();
    user.id = dto.id;
    user.accountIdentifier = dto.accountIdentifier;
    user.accountSource = dto.accountSource;
    user.businessLabel = dto.businessLabel
      ? BusinessLabel.fromDto(dto.businessLabel)
      : undefined!;
    user.className = dto.className;
    user.emailAddress = dto.emailAddress;
    user.firstName = dto.firstName;
    user.gender = dto.gender;
    user.lastName = dto.lastName;
    user.lastNamePrefix = dto.lastNamePrefix;
    user.name = dto.name;
    user.school = dto.school;
    user.schoolLevel = dto.schoolLevel;
    user.year = dto.year;
    user.roles = dto.roles ?? [];
    return user;
  }
}
